const initFaqSections = () => {
  document.querySelectorAll('[data-faq-section]').forEach((section) => {
    if (section.dataset.initialized) return;

    const loadMore = section.querySelector('[data-faq-load-more]');
    const animations = new WeakMap();
    const prefersReducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setItemState = (item, shouldOpen) => {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.faq-section__answer');

      if (
        !summary ||
        !answer ||
        prefersReducedMotion ||
        typeof item.animate !== 'function'
      ) {
        item.open = shouldOpen;
        return;
      }

      const activeState = animations.get(item);
      const startHeight = item.getBoundingClientRect().height;

      if (activeState) {
        item.style.height = `${startHeight}px`;
        activeState.animation.cancel();
        animations.delete(item);
      }

      if (shouldOpen) item.open = true;

      const borderHeight = item.offsetHeight - item.clientHeight;
      const endHeight =
        (shouldOpen ? item.scrollHeight : summary.offsetHeight) + borderHeight;
      item.style.height = `${startHeight}px`;
      item.style.overflow = 'hidden';

      const animation = item.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: 300, easing: 'ease-in-out' }
      );
      const state = { animation, targetOpen: shouldOpen };

      animations.set(item, state);

      animation.onfinish = () => {
        if (animations.get(item) !== state) return;

        item.open = shouldOpen;
        item.style.height = '';
        item.style.overflow = '';
        animations.delete(item);
      };
    };

    section.querySelectorAll('[data-faq-item]').forEach((item) => {
      const summary = item.querySelector('summary');

      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;

        event.preventDefault();

        const activeState = animations.get(item);
        const shouldOpen = !(activeState?.targetOpen ?? item.open);

        if (shouldOpen) {
          section.querySelectorAll('[data-faq-item]').forEach((openItem) => {
            const openItemState = animations.get(openItem);
            const isOpen = openItemState?.targetOpen ?? openItem.open;

            if (openItem !== item && isOpen) {
              setItemState(openItem, false);
            }
          });
        }

        setItemState(item, shouldOpen);
      });
    });

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        const hiddenItems = Array.from(
          section.querySelectorAll('[data-faq-item][hidden]')
        );

        hiddenItems.forEach((item, index) => {
          item.hidden = false;

          if (prefersReducedMotion || typeof item.animate !== 'function') {
            return;
          }

          item.animate(
            [
              { opacity: 0, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' },
            ],
            {
              duration: 350,
              delay: index * 70,
              easing: 'ease-out',
              fill: 'backwards',
            }
          );
        });

        loadMore.remove();
      });
    }

    section.dataset.initialized = 'true';
  });
};

document.addEventListener('DOMContentLoaded', initFaqSections);
